import { makeRequest } from "./general";

const apiUrl = window.apiUrl;
export default class SmsService {
  constructor() {
    this.baseUrl = apiUrl;
  }

  async send(transaction) {
    const url = `${this.baseUrl}/api/Sms/send`;
    const formData = {
      idLead: transaction.idLead,
    };
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Channel": transaction.utmClient,
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };

    return await makeRequest(url, params);
  }

  async verify(transaction, code) {
    const formData = {
      idLead: transaction.idLead,
      code: code,
    };
    const url = `${this.baseUrl}/api/Sms/verify`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Channel": transaction.utmClient,
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };

    return await makeRequest(url, params);
  }

  async resend(transaction) {
    const formData = {
      idLead: transaction.idLead,
    };
    const url = `${this.baseUrl}/api/Sms/resend`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Channel": transaction.utmClient,
        Authorization: `Bearer ${transaction.transactionId}/${transaction.document}`,
      },
      body: JSON.stringify(formData),
    };

    return await makeRequest(url, params);
  }
}
